import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { Header } from "../components/layout/header/Header";
import { Footer } from "../components/layout/footer/Footer";
import { api } from "../config/api";

export const NewsDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [newsList, setNewsList] = useState(null);
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  useEffect(() => {
    fetch(api("/api/get-news-events/"))
      .then((response) => response.json())
      .then((json) => setPosts(json));
  }, []);

  useEffect(() => {
    fetch(api(`/api/get-news-events/${id}`))
      .then((response) => response.json())
      .then((json) => setNewsList(json));
  }, [id]);

  if (!newsList || posts.length === 0) return <div>Loading...</div>;

  // Exclude the current news item from the list
  const filteredPosts = posts.filter((post) => post.id !== parseInt(id));

  const totalPages = Math.ceil(filteredPosts.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const currentPosts = filteredPosts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Function to remove <p> tags from content
  const removePTags = (htmlString) => {
    return htmlString.replace(/<\/?p>/g, "");
  };

  const cleanedDescription = removePTags(newsList.description);

  return (
    <div>
      <Header />

      {/* Sub banner */}
      <div className="sub_banner">
        <div className="container">
          <div className="banner_content_desc">
            <h5 className="banner_subtitle">News</h5>
            <h1 className="banner_title">{newsList.title}</h1>
            <div className="breadcrumb_detail">
              <div className="breadcrumb_box_grey">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      News
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="news_detail_inner">
        <div className="container">
          <div className="row gy-4 justify-content-center">
            <div className="col-lg-7">
              <div className="event_img">
                <img src={newsList.image_url} alt={newsList.title} />
              </div>
              <div className="card_body">
                <div className="event_detail">
                  <div className="row gy-4 gx-0 align-items-center">
                    <div className="col-lg-2">
                      <h5 className="news_box_month">{newsList.news_month}</h5>
                      <h3 className="news_box_date">{newsList.month_date}</h3>
                    </div>
                    <div className="col-lg-10">
                      <h2 className="event_title">{newsList.title}</h2>
                    </div>
                  </div>
                </div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: cleanedDescription,
                  }}></p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="latest_news_list">
                <div className="row gy-4">
                  {currentPosts.map((item) => (
                    <div className="col-lg-12" key={item.id}>
                      <div className="latest_news_box">
                        <div className="row">
                          <div className="col-lg-4">
                            <div className="card_img">
                              <img src={item.image_url} alt={item.title} />
                            </div>
                          </div>
                          <div className="col-lg-8">
                            <div className="card_body">
                              <h2 className="card_title">{item.title}</h2>
                              <p className="card_text">
                                {item.short_description}
                              </p>
                              <p className="card_link mb-0">
                                <Link
                                  to={`/News/${item.id}`}
                                  onClick={() => window.scrollTo(0, 0)}
                                  className="card_link">
                                  Read More{" "}
                                  <i className="bi bi-chevron-right"></i>
                                </Link>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-4">
                  <nav aria-label="Page navigation example">
                    <ul className="pagination justify-content-end mt-5">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}>
                        <button
                          className="page-link prev"
                          onClick={() => handlePageChange(currentPage - 1)}>
                          <i className="bi bi-chevron-left"></i>
                        </button>
                      </li>
                      {Array.from({ length: totalPages }, (_, i) => (
                        <li
                          key={i}
                          className={`page-item ${
                            currentPage === i + 1 ? "active" : ""
                          }`}>
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(i + 1)}>
                            {i + 1}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}>
                        <button
                          className="page-link next"
                          onClick={() => handlePageChange(currentPage + 1)}>
                          <i className="bi bi-chevron-right"></i>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
